// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-layer-box .wm-box {
  position: relative;
  margin: 10px;
  border-radius: 15px;
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  transition: all 500ms;
  height: 100%;
  max-height: 176px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
wm-layer-box .wm-box .color {
  position: absolute;
  border-radius: 15px;
  clip-path: polygon(100% 0, calc(100% - 30px) 0, 100% 30px);
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  height: 100%;
  width: 100%;
  z-index: 1;
}
wm-layer-box .wm-box .wm-box-icon {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin: 0;
  height: 48px;
  width: 48px;
  margin: 10px;
  border-width: 1px;
  z-index: 2;
}
wm-layer-box .wm-box .wm-box-icon svg {
  height: 100%;
}
wm-layer-box .wm-box wm-img {
  height: 100%;
}
wm-layer-box .wm-box wm-img img {
  position: absolute;
  border-radius: 15px;
  object-fit: cover;
  align-self: stretch;
  height: 100%;
  width: 100%;
  filter: brightness(75%);
}
wm-layer-box .wm-box .wm-box-title {
  font-size: 26px;
  font-family: var(--wm-font-family-content, inherit);
  font-style: normal;
  font-weight: 700;
  color: white;
  position: absolute;
  bottom: 0;
  padding: 6%;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
  white-space: break-spaces;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/box/layer-box/layer-box.component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAEI;EACE,kBAAA;EACA,mBAAA;EACA,0DAAA;EACA,8CAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAAN;AAEI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEA,iBAAA;EAIA,UAAA;AAJN;AACM;EACE,YAAA;AACR;AAGI;EACE,YAAA;AADN;AAEM;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AAAR;AAII;EACE,eAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAHN","sourcesContent":["wm-layer-box {\n  .wm-box {\n    position: relative;\n    margin: 10px;\n    border-radius: 15px;\n    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n    transition: all 500ms;\n    height: 100%;\n    max-height: 176px;\n    cursor: pointer;\n\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    .color {\n      position: absolute;\n      border-radius: 15px;\n      clip-path: polygon(100% 0, calc(100% - 30px) 0, 100% 30px);\n      box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n      height: 100%;\n      width: 100%;\n      z-index: 1;\n    }\n    .wm-box-icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      margin: 0;\n      height: 48px;\n      width: 48px;\n      margin: 10px;\n\n      border-width: 1px;\n      svg {\n        height: 100%;\n      }\n      z-index: 2;\n    }\n    wm-img {\n      height: 100%;\n      img {\n        position: absolute;\n        border-radius: 15px;\n        object-fit: cover;\n        align-self: stretch;\n        height: 100%;\n        width: 100%;\n        filter: brightness(75%);\n      }\n    }\n\n    .wm-box-title {\n      font-size: 26px;\n      font-family: var(--wm-font-family-content, inherit);\n      font-style: normal;\n      font-weight: 700;\n      color: white;\n      position: absolute;\n      bottom: 0;\n      padding: 6%;\n\n      line-height: 31px;\n      letter-spacing: 0em;\n      text-align: left;\n      white-space: break-spaces;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
